<template>
    <button type="submit" class="btn" :class="classes">
        {{text}}
    </button>
</template>

<script>
  export default {
    name: 'formButton',
    props: ['text', 'classes']
  }
</script>
